import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { dismissHtmlSplash } from '../../utils/dismissHtmlSplash';

const useStyles = makeStyles({
  root: {
    position: 'fixed',
    inset: 0,
    zIndex: 9998,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8fafc',
    gap: 16,
  },
  spinner: {
    color: '#3b82f6',
  },
  label: {
    fontSize: '0.9rem',
    color: '#64748b',
    fontWeight: 500,
  },
});

const AppLoadingScreen = ({ message = 'Carregando...' }) => {
  const classes = useStyles();

  useEffect(() => {
    dismissHtmlSplash();
  }, []);

  return (
    <Box className={classes.root} role="status" aria-live="polite" aria-busy="true">
      <CircularProgress size={56} thickness={4} className={classes.spinner} />
      {message ? (
        <Typography className={classes.label} component="p">
          {message}
        </Typography>
      ) : null}
    </Box>
  );
};

export default AppLoadingScreen;
